<template>
    <div class="layout__container">
        <div class="layout__padding-20px">
            <div class="text__align-center text__colour-white layout__margin__bottom-25px">
                <div class="layout__padding-clear layout__width-50 layout__padding-20-0 layout__border__bottom-light-teal-1px">
                    <h3 class="text__colour-teal">View a user or Edit a user</h3>
                </div>
            </div>

            <div>
                <!--<div class="component__columns-2 layout__overflow-hidden layout__border__all-1px-grey">-->
                <div class="layout__width-460px layout__overflow-hidden layout__border__all-1px-grey layout__position-left layout__margin__right-20px">
                    <div class="layout__padding-20px">
                        <h4 class="text__colour-teal text__align-center">View a user</h4>
                        <div class="layout__margin-20-0 layout__border__bottom-light-teal-1px">
                            <h5 class="text__align-center"><span class="text__colour-red">*</span> A read only view of
                                the user account</h5>
                            <h5 class="text__align-center layout__padding__bottom-6px">&nbsp;</h5>
                        </div>

                        <el-form :model="view_user" ref="create_user" :rules="rules"
                                 class="layout__width-100 layout__position-left layout__padding-20px">
                            <div>
                                <h3 class="text__colour-teal">{{this.view_user.emailAddress}}</h3>
                            </div>
                            <div>
                                <div class="layout__padding__top-20px">Account or Online User</div>
                                <p>{{this.userType}}</p>
                            </div>
                            <div>
                                <div class="layout__padding__top-20px">Branch Name</div>
                                <p>{{this.view_user.branchName}}</p>
                            </div>
                            <div>
                                <div class="layout__padding__top-20px">Contact</div>
                                <p>{{this.view_user.contact}}</p>
                            </div>
                            <div>
                                <div class="layout__padding__top-20px">Customer Name</div>
                                <p>{{this.view_user.customerName}}</p>
                            </div>
                            <div>
                                <div class="layout__padding__top-20px">Account Branch Code</div>
                                <p>{{this.view_user.customerRef}}</p>
                            </div>
                            <div>
                                <div class="layout__padding__top-20px">Active User</div>
                                <p v-if="view_user.abpUserId !== 0">Active</p>
                                <p v-else>Not Active</p>
                            </div>
                            <div>
                                <div class="layout__padding__top-20px">Email Address</div>
                                <p>{{this.view_user.emailAddress}}</p>
                            </div>
                            <div>
                                <div class="layout__padding__top-20px">Phone Number</div>
                                <p>{{this.view_user.phone}}</p>
                            </div>
                            <div>
                                <div class="layout__padding__top-20px">Postcode</div>
                                <p>{{this.view_user.postcode}}</p>
                            </div>
                            <div>
                                <div class="layout__padding__top-20px">Original Password Source</div>
                                <p>{{this.view_user.pwSource}}</p>
                            </div>
                        </el-form>
                    </div>

                    <div class="layout__padding-clear text__align-center">
                        <el-button
                                class="button-teal button__base layout__width-200px layout__margin-20px layout__position-left"
                                v-on:click="resetPassword()" :disabled="this.view_user.abpUserId === 0">Reset Password
                        </el-button>
                        <el-button
                                class="button-red button__base layout__width-200px layout__margin-20px layout__position__relative layout__display-inline-block text__align-center"
                                v-show="showUpgrade == true"
                                v-on:click="upgradeUser()">Upgrade To Account
                        </el-button>
                        <el-button
                                class="button-red button__base layout__width-200px layout__margin-20px layout__position__relative layout__display-inline-block text__align-center"
                                v-show="showUpgradeToAccount == true"
                                v-on:click="reviewCreditApplication()">Upgrade To Account
                        </el-button>
                        <el-button
                                class="button-red button__base layout__width-200px layout__margin-20px layout__position-right"
                                v-on:click="modifyUser()">Edit User Account
                        </el-button>

                    </div>
                </div>
            </div>

            <div class="component__columns-2 layout__overflow-hidden layout__border__all-1px-grey layout__margin__bottom-25px"
                 v-show="!enable_modify">
                <div class="layout__padding-20px">

                    <h4 class="text__colour-teal text__align-center">Edit a user</h4>
                    <h5 class="text__align-center layout__border__bottom-light-teal-1px layout__margin-20-0 layout__padding__bottom-6px">
                        <span class="text__colour-red">*</span> Modify actions will only save if the user has already
                        logged into MyRavensworth</h5>

                    <el-form :model="modify_user" ref="modify_user" :rules="rules"
                             class="layout__width-100 layout__position-left" :disabled="enable_modify">
                        <div class="layout__padding-clear">

                        </div>
                        <el-form-item prop="email_address" class="layout__width-100">
                            <div class="layout__position-left layout__padding-clear layout__padding__top-6px">Email
                                Address
                            </div>
                            <h5 class="layout__padding-clear layout__padding-5-0">Email address of the user</h5>
                            <el-input :disabled="true" v-model="modify_user.email_address"
                                      class="layout__position-left">
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="reset_password" class="layout__width-100" >
                            <div class="layout__position-left layout__padding-clear layout__padding__top-6px">Clear
                                Password
                            </div>
                            <h5 class="layout__display-block layout__padding-clear">Remove all existing password for the
                                user</h5>
                            <h5 class="layout__display-block">Upon login with <span
                                    class="text__colour-red"> MyRav2020 </span> the user will be emailed a password
                                reset link</h5>
                            <h5 class="layout__display-block">The user will be redirected to reset the password</h5>
                            <h5 class="layout__display-block">Can only be used if the user is <span class="text__colour-red">NOT</span> active</h5>
                            <el-checkbox v-model="reset_password" :disabled="view_user.abpUserId !== 0" v-on:change="modify_user.password = ''">&nbsp;
                            </el-checkbox>
                        </el-form-item>
                        <el-form-item prop="customer_branch" class="layout__width-100">
                            <div class="layout__position-left layout__padding-clear layout__padding__top-6px">Customer
                                Refs
                            </div>
                            <h5 class="layout__padding-clear layout__padding-5-0">Customer Branch Code (leave empty for
                                Online only users)</h5>
                            <el-input v-model="modify_user.customer_branch" class="layout__position-left">
                            </el-input>
                            <h5 class="layout__padding-clear layout__padding-5-0">Comma separated list is the required
                                input format for Multi-branch users: XXX1,XXX2</h5>
                        </el-form-item>
                        <el-form-item prop="first_name" class="layout__width-100">
                            <div class="layout__position-left layout__padding-clear layout__padding__top-6px">First
                                name
                            </div>
                            <h5 class="layout__padding-clear layout__padding-5-0">User's first name</h5>
                            <el-input v-model="modify_user.first_name" class="layout__position-left">
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="last_name" class="layout__width-100">
                            <div class="layout__position-left layout__padding-clear layout__padding__top-6px">Last
                                name
                            </div>
                            <h5 class="layout__padding-clear layout__padding-5-0">User's last name</h5>
                            <el-input v-model="modify_user.last_name" class="layout__position-left">
                            </el-input>
                        </el-form-item>
                        <el-button class="button-red button__base layout__width-200px layout__margin-30-0"
                                   v-on:click="postModifyUser('modify_user')">Modify User
                        </el-button>
                        <!--<el-button-->
                                <!--class="button-teal button__base layout__width-200px layout__margin-30-0 layout__position-right">-->
                            <!--Cancel-->
                        <!--</el-button>-->

                    </el-form>

                    <div id="success">
                        <p class="component__message-base component__message-success">User account successfully updated.
                            <br>Please advise users to logout and log back into the system to see changes made</p>
                    </div>
                    <div id="error">
                        <p class="component__message-base component__message-fail">There was an error updating the user<br> Please contact the Development team with the details entered above </p>
                    </div>
                    <div id="error_branch">
                        <p class="component__message-base component__message-fail">Invalid branch code used to setup the user account <br> Please amend the branch code and try again.</p>
                    </div>
                </div>
            </div>

            <div class="component__columns-2 layout__overflow-hidden layout__border__all-1px-grey layout__margin__bottom-25px"
                 v-show="showReviewCreditApplication">
                <div class="layout__padding-20px">

                    <h4 class="text__colour-teal text__align-center">Review Credit Application</h4>
                    <div class="layout__margin-20-0 layout__border__bottom-light-teal-1px">
                        <h5 class="text__align-center">Approve or reject this credit account application</h5>
                        <h5 class="text__align-center layout__padding__bottom-6px">&nbsp;</h5>
                    </div>

                    <el-form :model="approvalForm" status-icon ref="approvalForm">
                        <el-col :span="5">
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">Account Type</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">Company Name*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">Branch Name*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">Brand Name</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">Branch Address 1*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">Branch Address 2</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">Branch Address 3</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">Town*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">County*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">Postcode*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">Payment</div>

                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px layout__width-200-minus-20px layout__break-word text__size-12">
                                    Don't email me about product updates. If this box is left unticked, Ravensworth will occasionally send helpful and relevant emails. You can unsubscribe at any time.
                                </div>
                        </el-col>

                        <el-col :span="7">
                            <el-form-item class="layout__width-100-minus-20px" prop="account_type">
                                <!--<el-input class="layout__width-250px" placeholder="Account Type"
                                            v-model="approvalForm.accountType" readonly></el-input>-->
                                <el-input placeholder="Account Type"
                                            v-model="approvalForm.accountType" readonly></el-input>
                            </el-form-item>

                            <el-form-item class="layout__width-100-minus-20px" prop="company_name">
                                <el-input placeholder="Company Name"
                                            v-model="approvalForm.companyName" clearable autofocus></el-input>
                            </el-form-item>

                            <el-form-item class="layout__width-100-minus-20px" prop="branch_name">
                                <el-input placeholder="Branch Name"
                                            v-model="approvalForm.branchName" clearable></el-input>
                            </el-form-item>

                            <el-form-item class="layout__width-100-minus-20px" prop="brand_name">
                                <el-input placeholder="Brand Name"
                                            v-model="approvalForm.brandName" clearable></el-input>
                            </el-form-item>

                            <el-form-item class="layout__width-100-minus-20px" prop="branch_address1">
                                <el-input placeholder="Branch Address 1"
                                            v-model="approvalForm.branchAddressLine1" clearable></el-input>
                            </el-form-item>

                            <el-form-item class="layout__width-100-minus-20px" prop="branch_address2">
                                <el-input placeholder="Branch Address 2"
                                            v-model="approvalForm.branchAddressLine2" clearable></el-input>
                            </el-form-item>

                            <el-form-item class="layout__width-100-minus-20px" prop="branch_address3">
                                <el-input placeholder="Branch Address 3"
                                            v-model="approvalForm.branchAddressLine3" clearable></el-input>
                            </el-form-item>

                            <el-form-item class="layout__width-100-minus-20px" prop="branch_town">
                                <el-input placeholder="Town"
                                            v-model="approvalForm.branchTown" clearable></el-input>
                            </el-form-item>

                            <el-form-item class="layout__width-100-minus-20px" prop="branch_county">
                                <el-input placeholder="County"
                                            v-model="approvalForm.branchCounty" clearable></el-input>
                            </el-form-item>

                            <el-form-item class="layout__width-100-minus-20px" prop="branch_postcode">
                                <el-input placeholder="Postcode"
                                            v-model="approvalForm.branchPostcode" clearable></el-input>
                            </el-form-item>

                            <el-form-item class="layout__width-100-minus-20px" prop="payment_method">
                                <el-input placeholder="Payment"
                                            v-model="approvalForm.paymentMethod" readonly></el-input>
                            </el-form-item>

                            <el-form-item class="layout__position-right layout__width-35px">
                                <el-checkbox class="layout__border__bottom-none text__direction-left-to-right" v-model="approvalForm.marketingEmailsConsent"></el-checkbox>
                            </el-form-item>
                        </el-col>

                        <el-col :span="5">
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">Main Contact First Name*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">Main Contact Surname*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">Main Contact Telephone*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">Main Contact Email*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">Accounts Contact*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">Accounts Contact Telephone*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">Invoice Email Address*</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">Billing Address 1</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">Billing Address 2</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">Billing Address 3</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">Town</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">County</div>
                                <div class="text__colour-teal layout__padding-5-0 layout__height-35px text__size-12">Postcode</div>
                        </el-col>

                        <el-col :span="7">
                            <el-form-item class="layout__width-100-minus-20px" prop="main_contact_firstname">
                                <el-input placeholder="Main Contact First Name"
                                            v-model="approvalForm.mainContactFirstName" clearable></el-input>
                            </el-form-item>

                            <el-form-item class="layout__width-100-minus-20px" prop="main_contact_surname">
                                <el-input placeholder="Main Contact Surname"
                                            v-model="approvalForm.mainContactLastName" clearable></el-input>
                            </el-form-item>

                            <el-form-item class="layout__width-100-minus-20px" prop="main_contact_telephone">
                                <el-input placeholder="Main Contact Telephone"
                                            v-model="approvalForm.mainContactTelephone" clearable></el-input>
                            </el-form-item>

                            <el-form-item class="layout__width-100-minus-20px" prop="main_contact_email">
                                <el-input placeholder="Main Contact Email"
                                            v-model="approvalForm.mainContactEmail" clearable></el-input>
                            </el-form-item>

                            <el-form-item class="layout__width-100-minus-20px" prop="accounts_contact_name">
                                <el-input placeholder="Accounts Contact"
                                            v-model="approvalForm.accountsContactName" clearable></el-input>
                            </el-form-item>

                            <el-form-item class="layout__width-100-minus-20px" prop="accounts_contact_telephone">
                                <el-input placeholder="Accounts Contact Telephone"
                                            v-model="approvalForm.accountsContactTelephone" clearable></el-input>
                            </el-form-item>

                            <el-form-item class="layout__width-100-minus-20px" prop="accounts_contact_email">
                                <el-input placeholder="Invoice Email Address"
                                            v-model="approvalForm.accountsEmail" clearable></el-input>
                            </el-form-item>

                            <el-form-item class="layout__width-100-minus-20px" prop="billing_address1">
                                <el-input placeholder="Billing Address 1"
                                            v-model="approvalForm.billingAddressLine1" clearable></el-input>
                            </el-form-item>

                            <el-form-item class="layout__width-100-minus-20px" prop="billing_address2">
                                <el-input placeholder="Billing Address 2"
                                            v-model="approvalForm.billingAddressLine2" clearable></el-input>
                            </el-form-item>

                            <el-form-item class="layout__width-100-minus-20px" prop="billing_address3">
                                <el-input placeholder="Billing Address 3"
                                            v-model="approvalForm.billingAddressLine3" clearable></el-input>
                            </el-form-item>

                            <el-form-item class="layout__width-100-minus-20px" prop="billing_town">
                                <el-input placeholder="Town"
                                            v-model="approvalForm.billingTown" clearable></el-input>
                            </el-form-item>

                            <el-form-item class="layout__width-100-minus-20px" prop="billing_county">
                                <el-input placeholder="County"
                                            v-model="approvalForm.billingCounty" clearable></el-input>
                            </el-form-item>

                            <el-form-item class="layout__width-100-minus-20px" prop="billing_postcode">
                                <el-input placeholder="Postcode"
                                            v-model="approvalForm.billingPostcode" clearable></el-input>
                            </el-form-item>
                        </el-col>

                        <div class="layout__padding-clear layout__padding__top-20px">
                            <div class="layout__padding-clear">
                                <el-button class="button-red button__base layout__width-200px layout__margin-20px layout__position-left"
                                            v-on:click="acceptApplication()">Accept
                                </el-button>
                                <el-button class="button-red button__base layout__width-200px layout__margin-20px layout__position-right"
                                            v-on:click="rejectApplication()">Reject
                                </el-button>
                            </div>
                        </div>
                    </el-form>
                </div>
            </div>

            <!-- TEMPORARILT HIDDEN -->
            <!--<div class="component__columns-3 layout__overflow-hidden layout__border__all-1px-grey layout__margin__bottom-25px layout__width-500px"
                 v-show="showReviewCreditApplication">-->
            <div class="component__columns-3 layout__overflow-hidden layout__border__all-1px-grey layout__margin__bottom-25px layout__width-500px"
                 v-show=false>
                <div class="layout__padding-20px">

                    <h4 class="layout__margin__bottom-20 text__colour-teal text__align-center">Match Customer</h4>

                    <el-table :data="customers" style="width: 100%;" 
                              :show-header=false
                              :highlight-current-row=false
                              :class-name="cellStyle"
                              row-class-name="no-hover"
                              v-loading.fullscreen.lock="loading">
                        <el-table-column width="230">
                            <template slot-scope="scope">
                                <span class="text__white_space-pre">{{scope.row.customer_details}}</span>
                            </template>
                        </el-table-column>

                        <el-table-column width="230">
                            <template slot-scope="customer">
                                <el-button class="button-red button__base layout__width-200px layout__margin-20px layout__position-center"
                                            v-on:click="matchCustomer(customer)">Match
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>

            <div class="component__columns-2 layout__overflow-hidden layout__border__all-1px-grey layout__margin__bottom-25px"
                 v-show="!enable_password">
                <div class="layout__padding-20px">

                    <h4 class="text__colour-teal text__align-center">Edit an active user password</h4>
                    <h5 class="text__align-center layout__border__bottom-light-teal-1px layout__margin-20-0 layout__padding__bottom-6px">
                        <span class="text__colour-red">*</span> Modify actions will only save if the user has already
                        logged into MyRavensworth</h5>

                    <el-form :model="modify_user" ref="reset_password" :rules="rules"
                             class="layout__width-100 layout__position-left" :disabled="enable_password">
                        <div class="layout__padding-clear">

                        </div>
                        <el-form-item prop="email_address" class="layout__width-100">
                            <div class="layout__position-left layout__padding-clear layout__padding__top-6px">Password
                            </div>
                            <h5 class="layout__padding-clear layout__padding-5-0">Password for customer user <br>(please
                                leave blank unless you are changing the password on behalf of the user)<br>This will
                                <span class="text__colour-red">NOT</span> trigger the password reset email</h5>
                            <el-input v-model="modify_user.password" class="layout__position-left">
                            </el-input>
                        </el-form-item>
                        <el-button class="button-red button__base layout__width-200px layout__margin-30-0"
                                   v-on:click="postPasswordReset('reset_password')">Update Password
                        </el-button>
                        <!--<el-button-->
                                <!--class="button-teal button__base layout__width-200px layout__margin-30-0 layout__position-right">-->
                            <!--Cancel-->
                        <!--</el-button>-->

                    </el-form>

                    <div id="success_password">
                        <p class="component__message-base component__message-success">User password successfully updated.</p>
                    </div>
                    <div id="error_password">
                        <p class="component__message-base component__message-fail">There was an error updating the password<br> Please contact the Development team with the details entered above </p>
                    </div>

                    <div id="success_approval">
                        <p class="component__message-base component__message-success">Credit application succesfully approved.</p>
                    </div>
                    <div id="error_approval">
                        <p class="component__message-base component__message-fail">There was an error approving the credit application<br> Please contact the Development team with the details entered above </p>
                    </div>

                    <div id="success_rejection">
                        <p class="component__message-base component__message-success">Credit application succesfully rejected.</p>
                    </div>
                    <div id="error_rejection">
                        <p class="component__message-base component__message-fail">There was an error rejecting the credit application<br> Please contact the Development team with the details entered above </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {backing} from '@/mixins/Backing.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {Loading} from 'element-ui';

    export default {
        name: "adminOrders",
        components: {},
        mixins: [axios, dataFormatter, backing, csvDownloadHelper],
        props: {
            view_user: Object
        },
        computed: {
            userType() {
                if (this.view_user.awaitingApproval === true) {
                    return 'AccountApplication';
                } else {
                    if (this.view_user.accountUser === true) {
                        return 'Account';
                    } else {
                        return 'Online';
                    }
                }
            }
        },
        data() {
            const focReason = (rule, value, callback) => {
                if (this.bespokeOrderItem.priceMethod === 'FOC' && this.bespokeOrderItem.focReason === '') {
                    callback(new Error('enter a foc reason required'));
                } else if (this.bespokeOrderItem.priceMethod !== 'FOC' && this.bespokeOrderItem.focReason !== '') {
                    callback(new Error('please remove foc reason - price method not \'FOC\''));
                } else {
                    callback();
                }
            };
            return {
                // view_user: {
                //     account_user: true,
                //     contact: 'Rifat Iqbal',
                //     customer_name: 'Ravensworth',
                //     customer_branch: 'XXX1',
                //     email_address: 'rifat.iqbal@ravensworth.co.uk',
                //     phone: '07512081721',
                //     postcode: 'NE64 6JD',
                //     pw_source: 'photofixr v1',
                // },
                modify_user: {
                    email_address: '',
                    password: null,
                    customer_branch: '',
                    clear_password: true,
                    first_name: '',
                    last_name: ''
                },
                approval: {},
                approvalForm: {},
                reset_password: false,
                enable_modify: true,
                enable_password: true,
                rules: {},
                userRole: [],
                customers: [],
                loading: false,
                showUpgrade: false,
                showUpgradeToAccount: false,
                showReviewCreditApplication: false,
            }
        },
        created() {
            this.isUserAuthorised();
        },
        mounted() {
            console.log(this.view_user);

            this.userRole = JSON.parse(window.sessionStorage.getItem('_role'));

            /*if (this.userRole.includes('RpsAdministrator') && !this.view_user.accountUser) {
                this.showUpgrade = true;
            }

            if (this.view_user.awaitingApproval == true) {
                this.showUpgradeToAccount = true;
            }*/

            if (this.userRole.includes('RpsAdministrator')) {
                if (this.view_user.awaitingApproval == true) {
                    this.checkCreditApplication();
                } else {
                    if (!this.view_user.accountUser) {
                        this.showUpgrade = true;
                    }
                }
            }

            //TEMPORARY!!!!
            this.customers = [
                {
                    'id': 1,
                    'company_name': 'New company name', 
                    'branch_name': 'New branch name', 
                    'email': 'online300@ravensworth.uk', 
                    'postcode': 'GL1 3BT',
                    'customer_details': 'New company name\nNew branch name\nonline300@ravensworth.uk\nGL1 3BT',
                },
                {
                    'id': 2,
                    'company_name': 'New company name', 
                    'branch_name': 'New branch name', 
                    'email': 'online300@ravensworth.uk', 
                    'postcode': 'GL1 3BT',
                    'customer_details': 'New company name\nNew branch name\nonline300@ravensworth.uk\nGL1 3BT',
                },
                {
                    'id': 3,
                    'company_name': 'New company name', 
                    'branch_name': 'New branch name', 
                    'email': 'online300@ravensworth.uk', 
                    'postcode': 'GL1 3BT',
                    'customer_details': 'New company name\nNew branch name\nonline300@ravensworth.uk\nGL1 3BT',
                },
                {
                    'id': 4,
                    'company_name': 'New company name', 
                    'branch_name': 'New branch name', 
                    'email': 'online300@ravensworth.uk', 
                    'postcode': 'GL1 3BT',
                    'customer_details': 'New company name\nNew branch name\nonline300@ravensworth.uk\nGL1 3BT',
                },
            ];

            document.getElementById('error').style.display = 'none';
            document.getElementById('success').style.display = 'none';
            document.getElementById('error_password').style.display = 'none';
            document.getElementById('success_password').style.display = 'none';
            document.getElementById('error_branch').style.display = 'none';

            document.getElementById('success_approval').style.display = 'none';
            document.getElementById('error_approval').style.display = 'none';
            document.getElementById('success_rejection').style.display = 'none';
            document.getElementById('error_rejection').style.display = 'none';
        },
        beforeDestroy() {
        },
        methods: {
            modifyUser() {
                this.modify_user.email_address = this.view_user.emailAddress;
                this.enable_modify = false;
                this.enable_password = true;
                this.showReviewCreditApplication = false;
            },
            upgradeUser() {
                let loadingInstance = Loading.service({
                    fullscreen: true
                });
                        
                const url = `${process.env.VUE_APP_INTERNAL_ACCOUNTS}/api/services/app/Customer/UpgradeOnlineCustomer?customerRef=` + this.view_user.customerRef + `&whatIfMode=false`

                console.log(url)

                 Axios.put(url, {}, this.returnHeaderInternal())
                    .then(response => {
                        console.log(response);

                        this.$nextTick(() => { // Loading should be closed asynchronously
                            this.view_user.accountUser = true;
                            this.view_user.customerRef = response.data.result.ref;
                            this.showUpgrade = false;

                            loadingInstance.close();
                            document.getElementById('success').style.display = 'block';
                        })
                    })
                    .catch(error => {
                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                            document.getElementById('error').style.display = 'block';
                        });
                    }); 
            },
            resetPassword() {
                this.modify_user.email_address = this.view_user.emailAddress;
                this.enable_modify = true;
                this.enable_password = false;
            },
            postModifyUser(modify_user) {
                this.$refs[modify_user].validate((valid) => {
                    if (valid) {

                        let loadingInstance = Loading.service({
                            fullscreen: true
                        });

                        const url = `${process.env.VUE_APP_INTERNAL_ACCOUNTS}/api/services/app/Maintenance/RepairCustomerUserAccount`

                        // const modify_account = {
                        //     "userId": this.view_user.abpUserId,
                        //     "emailAddress": this.modify_user.email_address,
                        //     "password": this.modify_user.password,
                        //     "customerRefs": this.modify_user.customer_branch,
                        //     "companyName": "",
                        //     "name": this.modify_user.first_name,
                        //     "surname": this.modify_user.last_name,
                        //     "isOnlineOnlyUser": this.view_user.accountUser,
                        // }

                        let modify_account = {};

                        modify_account["userId"] = this.view_user.abpUserId;

                        if (this.modify_user.customer_branch) {
                            modify_account["customerRefs"] = this.modify_user.customer_branch
                        }
                        if (this.modify_user.first_name) {
                            modify_account["name"] = this.modify_user.first_name
                        }
                        if (this.modify_user.last_name) {
                            modify_account["surname"] = this.modify_user.last_name
                        }
                        if (this.reset_password) {
                            modify_account["clearLegacyPassword"] = this.reset_password
                        }


                        console.log(modify_account)

                        Axios.post(url, modify_account, this.returnHeaderInternal())
                            .then(response => {
                                console.log(response)

                                document.getElementById('success').style.display = 'block';


                                const getUpdatedUser = `${process.env.VUE_APP_INTERNAL_ACCOUNTS}/odata/userSearch?$filter=emailAddress+eq+'` + this.view_user.emailAddress + '\'+and+accountUser+eq+true&$skip=0&$top=20'

                                Axios.get(getUpdatedUser, this.returnHeaderUsingToken())
                                    .then(response => {
                                        console.log(response.data)

                                        this.view_user = response.data.value[0]

                                    })
                                    .catch(error => {
                                    })

                                this.$nextTick(() => { // Loading should be closed asynchronously
                                    loadingInstance.close();
                                })

                            })
                            .catch(error => {
                                this.$nextTick(() => { // Loading should be closed asynchronously
                                    loadingInstance.close();
                                });

                                console.log(error.response.data.error)

                                if (error.response.data.error.details === "Invalid customer ref(s)") {
                                    document.getElementById('error_branch').style.display = 'block';
                                } else {
                                    document.getElementById('error').style.display = 'block';
                                }
                            });

                    } else {
                        return false;
                    }
                })
            },
            postPasswordReset(reset_password) {
                this.$refs[reset_password].validate((valid) => {
                    if (valid) {

                        let loadingInstance = Loading.service({
                            fullscreen: true
                        });

                        const url = `${process.env.VUE_APP_INTERNAL_ACCOUNTS}/api/services/app/Maintenance/SetTkUserPassword?userId=` + this.view_user.abpUserId + '&plainPassword=' + this.modify_user.password

                        console.log(url)

                        Axios.post(url, {}, this.returnHeaderInternal())
                            .then(response => {
                                console.log(response)

                                document.getElementById('success_password').style.display = 'block';

                                // const getUpdatedUser = `${process.env.VUE_APP_INTERNAL_ACCOUNTS}/odata/userSearch?$filter=emailAddress+eq+'` + this.view_user.emailAddress + '\'+and+accountUser+eq+true&$skip=0&$top=20'
                                //
                                //
                                //
                                // Axios.get(getUpdatedUser, this.returnHeaderUsingToken())
                                //     .then(response => {
                                //         console.log(response.data)
                                //
                                //         this.view_user = response.data.value[0]
                                //
                                //     })
                                //     .catch(error => {
                                //     })
                                this.$nextTick(() => { // Loading should be closed asynchronously
                                    loadingInstance.close();
                                })
                            })
                            .catch(error => {
                                this.$nextTick(() => { // Loading should be closed asynchronously
                                    loadingInstance.close();
                                });

                                document.getElementById('error_password').style.display = 'block';
                            });

                    } else {
                        return false;
                    }
                })
            },
            checkCreditApplication() {

                let loadingInstance = Loading.service({
                    fullscreen: true
                });

                const getPendingApprovals = `${process.env.VUE_APP_INTERNAL_ACCOUNTS}/api/services/app/Approvals/GetPendingApprovals?&userIdFilter=` + this.view_user.abpUserId;

                Axios.get(getPendingApprovals, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response.data.result.length);

                        if (response.data.result.length > 0) {
                            this.showUpgradeToAccount = true;
                        }

                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        })
                    })
                    .catch(error => {
                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        })
                    })
            },
            reviewCreditApplication() {

                let loadingInstance = Loading.service({
                    fullscreen: true
                });

                const getPendingApprovals = `${process.env.VUE_APP_INTERNAL_ACCOUNTS}/api/services/app/Approvals/GetPendingApprovals?userIdFilter=` + this.view_user.abpUserId;

                Axios.get(getPendingApprovals, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response.data.result[0]);
                        console.log(response.data.result[0].submittedTkBackgroundJobArguments);

                        this.approval = response.data.result[0];
                        this.approvalForm = JSON.parse(this.approval.submittedTkBackgroundJobArguments);
                        this.enable_modify = true;
                        this.showReviewCreditApplication = true;

                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        })
                    })
                    .catch(error => {
                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        })
                    })
            },
            acceptApplication() {

                let userId = window.sessionStorage.getItem('_userId'),
                    submittedTkBackgroundJobArguments = JSON.stringify(this.approvalForm);

                let loadingInstance = Loading.service({
                    fullscreen: true
                });

                const updateApproval = `${process.env.VUE_APP_INTERNAL_ACCOUNTS}/api/services/app/Approvals/UpdateApproval`;

                const params = {
                    'tenantId': this.approval.tenantId,
                    'requesterUserId': this.approval.requesterUserId,
                    'approverUserId': userId,
                    'approvalType': 'CreditApplication',
                    'approvalStatus': 'APPROVED',
                    'submittedTkBackgroundJobName': this.approval.submittedTkBackgroundJobName,
                    'submittedTkBackgroundJobArguments': submittedTkBackgroundJobArguments,
                    'notes': this.approval.notes,
                    'approvalRequested': this.approval.approvalRequested,
                    'approvalProcessCompleted': new Date(),
                    'id': this.approval.id
                }

                Axios.put(updateApproval, params, this.returnHeaderInternal())
                    .then(response => {
                        console.log(response);

                        const processCreditApplication = `${process.env.VUE_APP_INTERNAL_ACCOUNTS}/api/services/app/Customer/ProcessAccountApplication?approvalId=` + this.approval.id.toUpperCase();
                        
                        Axios.post(processCreditApplication, {}, this.returnHeaderInternal())
                            .then(response => {
                                console.log(response);

                                this.showUpgradeToAccount = false;
                                this.showReviewCreditApplication = false;

                                document.getElementById('success_approval').style.display = 'block';

                                this.$nextTick(() => { // Loading should be closed asynchronously
                                    loadingInstance.close();
                                })
                            })
                            .catch(error => {
                                document.getElementById('error_approval').style.display = 'block';

                                this.$nextTick(() => { // Loading should be closed asynchronously
                                    loadingInstance.close();
                                });
                            });
                    })
                    .catch(error => {
                        document.getElementById('error_approval').style.display = 'block';

                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        });
                    });
            },
            rejectApplication() {

                let userId = window.sessionStorage.getItem('_userId');

                let loadingInstance = Loading.service({
                    fullscreen: true
                });

                const updateApproval = `${process.env.VUE_APP_INTERNAL_ACCOUNTS}/api/services/app/Approvals/UpdateApproval`;

                const params = {
                    'tenantId': this.approval.tenantId,
                    'requesterUserId': this.approval.requesterUserId,
                    'approverUserId': userId,
                    'approvalType': 'CreditApplication',
                    'approvalStatus': 'REJECTED',
                    'submittedTkBackgroundJobName': this.approval.submittedTkBackgroundJobName,
                    'submittedTkBackgroundJobArguments': this.approval.submittedTkBackgroundJobArguments,
                    'notes': this.approval.notes,
                    'approvalRequested': this.approval.approvalRequested,
                    'approvalProcessCompleted': new Date(),
                    'id': this.approval.id
                }

                Axios.put(updateApproval, params, this.returnHeaderInternal())
                    .then(response => {
                        console.log(response);

                        this.showUpgradeToAccount = false;
                        this.showReviewCreditApplication = false;

                        document.getElementById('success_rejection').style.display = 'block';

                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        })
                    })
                    .catch(error => {
                        document.getElementById('error_rejection').style.display = 'block';

                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        });
                    });
            },
            matchCustomer(customer) {
                console.log('matchCustomer: id=' + customer.row.id);



            },
            cellStyle() {
                return "text__white_space-pre";
            }
        }
    };
</script>